    import React, { useState, useEffect } from "react";
    import Flex from '@react-css/flex';
    import Modal from 'react-modal';
    import { StyledForm } from "../../styled-components/StyledForm.style";
    import { StyledTablePage } from "../../styled-components/StyledTablePage.style";
    import { ToggleSwitchFilters } from "../ToggleSwitchFilters";
    import api from '../../services/api';
    import Swal from "sweetalert2";
    import Select from 'react-select';

    export const ModalAprovacoesConcluir = ({
        loadTable,
        isOpen,
        setIsOpen,
        pendenciaDeAprovacao
    }) => {
        var [descricao, setDescricao] = useState(null);
        var [condicional, setCondicional] = useState(null);
        const [isLoading, setIsLoading] = useState(true);
        const [timesheet, setTimesheet] = useState([]);
        const [totalHoras, setTotalHoras] = useState(0);
        const [totalValor, settotalValor] = useState(0);
        const [totalHorasProBono, setTotalHorasProBono] = useState(0);
        const [totalValorProBono, settotalValorProBono] = useState(0);
        const [idSinistro, setIdSinistro] = useState(null);
        const [unificarFaturamentoToggle, setUnificarFaturamentoToggle] = useState(pendenciaDeAprovacao?.isFaturamentoMultiEmpresa === true);
        const [unificarFaturamentoOpcaoToggle, setUnificarFaturamentoOpcaoToggle] = useState(pendenciaDeAprovacao?.acoes?.unificarFaturamentoOpcao === true);
        
        const [toogleLabel, setToogleLabel] = useState(pendenciaDeAprovacao?.isFaturamentoMultiEmpresa === true ? 'Sim' : 'Não');
        const [toggleKey, setToggleKey] = useState(Date.now());

        const toggleConfig = { 
                                    name: `toggleConfig`, 
                                    id: `toggleConfig`, 
                                    label: toogleLabel, 
                                    status: unificarFaturamentoToggle, 
                                    checked: unificarFaturamentoToggle,
                                    disabled: unificarFaturamentoOpcaoToggle ? "disabled" : ""
                                };

        const style = {
            content: {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                borderRadius: "0px",
                minWidth: '40%',
                overflowY: 'auto',
                minHeight: '45%',
                maxHeight: '90%'
            },
            overlay: {
                zIndex: 9999
            }
        };

        const getCondicional = (condicional, condicionalResposta) => {
            if (!condicional) return

            setCondicional({
                idEtapaAprovacao: condicional.idEtapaAprovacao,
                IdEtapaCondicionalOpcao: condicionalResposta.value,
                NomeOpcao: condicionalResposta.label
            })
        };

        const getUnificarFaturamentoToggle = (status) => {
            setUnificarFaturamentoToggle(status);
            if (status) setToogleLabel('Sim');
            else setToogleLabel('Não');
        };

        const onAfterOpen = () => { };

        const closeModal = () => {
            setIsOpen(false);
        }

        const handleDescricao = (descricao) => {
            setDescricao(descricao.target.value);
        }

        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': false
            }
        }

        const getTimesheetById = async () => {
            setIsLoading(true);
            try {
                const response = await api.get(`Timesheet/vincular/${pendenciaDeAprovacao.idTimesheet}`, config);
                const data = response.data.data;
                setTimesheet(data);
                setIdSinistro(data[0].idSinistro);
                
                let idsIniciais = [pendenciaDeAprovacao.idTimesheet];

                const idsJaVinculados = data
                    .filter(tsItem => tsItem.vinculado === true)
                    .map(tsItem => tsItem.idTimesheet);

                const isEdicao = idsJaVinculados.length > 0;

                idsIniciais = [...idsIniciais, ...idsJaVinculados];

                if (!isEdicao) {
                    const isIndicacao = data.some(tsItem => tsItem.indicacao === true);

                    if (isIndicacao) {
                        const idsVinculaveis = data
                            .filter(tsItem => tsItem.podeVincular)
                            .map(tsItem => tsItem.idTimesheet);
                        
                        idsIniciais = [...idsIniciais, ...idsVinculaveis];
                    }
                }

                let totalHoras = 0;
                let totalValor = 0;
                let totalHorasProBono = 0;
                let totalValorProBono = 0;
                data.forEach((tsItem) => {
                    totalHoras += tsItem.totalHorasFaturadas;
                    totalValor += tsItem.valorTotalFaturadoD;

                    totalHorasProBono += tsItem.horasProBono;
                    totalValorProBono += tsItem.valorProBonoD;
                });
                setTotalHorasProBono(totalHorasProBono)
                settotalValorProBono(totalValorProBono)
                setTotalHoras(totalHoras);
                settotalValor(totalValor);

            } catch (err) {
                console.error("Error fetching timesheet:", err);
            } finally {
                setIsLoading(false);
            }
            return "Error";
        }

        const formatCurrency = (value) => {
            if (!value) {
                return 'R$ 0,00';
            }

            return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 });
        };

        const formatDecimal = (value) => {
            if (value == null || value === undefined || value === 0) {
                return '0,00';

            }
            return value.toLocaleString('pt-br', { style: 'decimal', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 });

        };

        const formActivities = async () => {
            if (pendenciaDeAprovacao.condicional && condicional == null && !pendenciaDeAprovacao.acoes.unificarFaturamento) {
                registrationInformation()
            }
            else {

                let payload = {
                    idPendenciaAprovacao: pendenciaDeAprovacao.idPendenciaAprovacao,
                    descricao: descricao,
                    // Aprovado
                    status: 2,
                    // Concluir
                    IdTipoAcao: 3,
                    IdEtapaCondicionalOpcao: pendenciaDeAprovacao.acoes.unificarFaturamento ? null : condicional?.IdEtapaCondicionalOpcao,
                    NomeOpcao: condicional?.NomeOpcao,
                    IdSinistro: idSinistro,
                    IsUnificar: unificarFaturamentoToggle
                }

                Swal.fire({
                    title: 'Aguarde...',
                    html: 'Concluindo...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    willOpen: () => {
                        Swal.showLoading()
                    },
                });


                if(pendenciaDeAprovacao?.atividadesProbono > 0) {
                    Swal.fire({
                        text: `Este TS possui ${pendenciaDeAprovacao?.totalHorasProBono} horas Pro bono, seguir com a aprovação?`,
                        showCancelButton: true,
                        showConfirmButton: true,
                        confirmButtonText: "Sim",
                        cancelButtonText: "Não",
                    }).then(async (result) => {
                    await api.put(`Aprovacoes/status`, payload)
                        .then(async (response) => {
                            await loadTable()
                            setIsOpen(false);
                            registrationSuccess();
                        })
                        .catch((error) => {
                            registrationFailure(error?.response?.data?.notification?.messageReturn)
                        });
                    });
                }
                else {
                await api.put(`Aprovacoes/status`, payload)
                    .then(async (response) => {
                        await loadTable()
                        setIsOpen(false);
                        registrationSuccess();
                    })
                    .catch((error) => {
                        registrationFailure(error?.response?.data?.notification?.messageReturn)
                    });
                }
            }
        };

        const registrationSuccess = () => {
            Swal.fire({
                title: "Sucesso",
                text: "Aprovado com sucesso",
                icon: "success",
                showConfirmButton: false,
                timer: 2500,
            });
        }

        const registrationFailure = (text = "Ops, ocorreu um erro!. Tente novamente em instantes.") => {
            Swal.fire({
                title: "Atenção",
                text: text,
                icon: "error",
                confirmButtonText: "OK",
            });
        }

        const registrationInformation = () => {
            Swal.fire({
                title: "Informação",
                text: "Preencha todos os campos necessários",
                icon: "info",
                confirmButtonText: "OK",
            });
        }

        useEffect(() => {
            const isUnificar = pendenciaDeAprovacao?.isFaturamentoMultiEmpresa === true;
            
            setCondicional(null);
            setDescricao(null);
            setTimesheet([]);
            setToogleLabel(isUnificar ? 'Sim' : 'Não');
            setUnificarFaturamentoToggle(isUnificar);
            
            // 2. ADICIONE ESTA LINHA (Ela força o remount com o valor já definido)
            setToggleKey(Date.now());
            
            if (pendenciaDeAprovacao?.idTimesheet) {
                getTimesheetById();
            }
        }, [pendenciaDeAprovacao, isOpen]);

        // Cálculos dinâmicos para as tabelas separadas
        const criterioTimesheets = timesheet.filter(tsItem => tsItem.vinculado && tsItem.idEmpresa === 1);
        const adjusterTimesheets = timesheet.filter(tsItem => tsItem.vinculado && tsItem.idEmpresa === 2);

        const totalCriterioHoras = criterioTimesheets.reduce((acc, curr) => acc + (curr.totalHorasFaturadas || 0), 0);
        const totalCriterioValor = criterioTimesheets.reduce((acc, curr) => acc + (curr.valorTotalFaturadoD || 0), 0);
        const totalCriterioHorasPB = criterioTimesheets.reduce((acc, curr) => acc + (curr.horasProBono || 0), 0);
        const totalCriterioValorPB = criterioTimesheets.reduce((acc, curr) => acc + (curr.valorProBonoD || 0), 0);

        const totalAdjusterHoras = adjusterTimesheets.reduce((acc, curr) => acc + (curr.totalHorasFaturadas || 0), 0);
        const totalAdjusterValor = adjusterTimesheets.reduce((acc, curr) => acc + (curr.valorTotalFaturadoD || 0), 0);
        const totalAdjusterHorasPB = adjusterTimesheets.reduce((acc, curr) => acc + (curr.horasProBono || 0), 0);
        const totalAdjusterValorPB = adjusterTimesheets.reduce((acc, curr) => acc + (curr.valorProBonoD || 0), 0);

        return (
            <Modal
                isOpen={isOpen}
                onAfterOpen={onAfterOpen}
                onRequestClose={closeModal}
                contentLabel="Aprovações concluir"
                style={style}
                ariaHideApp={false}
                shouldCloseOnOverlayClick={false}
            >
                <StyledForm>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="pull-left">
                                    <p className="modal-title"><i className="fa fa-check me-2" style={{ fontSize: '20px' }}></i>Concluir</p>
                                </div>
                                <div className="pull-right">
                                    <p className="modal-close" onClick={closeModal}><button className="default-button-red-small px-2">X</button></p>
                                </div>
                            </div>
                        </Flex.Item>
                    </Flex>
                </StyledForm>
                <StyledForm>
                    <StyledTablePage>
                        <div className="row mb-2" style={{ fontSize: "14px" }}>
                            <div className="col-3 text-center"><span style={{ color: "#999" }}>Sigla</span><br/>{ pendenciaDeAprovacao?.sigla || "-" }</div>
                            <div className="col-3 text-center"><span style={{ color: "#999" }}>Segurado</span><br/>{ pendenciaDeAprovacao?.segurado?.seguradoNome || pendenciaDeAprovacao?.segurado || "-" }</div>
                            <div className="col-3 text-center"><span style={{ color: "#999" }}>Aprovador/Reprovador</span><br/>{ pendenciaDeAprovacao?.nomeAprovador || "-" }</div>
                            <div className="col-3 text-center"><span style={{ color: "#999" }}>Empresa</span><br/>{ pendenciaDeAprovacao?.nomeEmpresa || "-" }</div>
                        </div>

                        <div className="row mb-2" style={{ fontSize: "14px" }}>
                            <div className="col-3 text-center"><span style={{ color: "#999" }}>Cliente</span><br/>{ pendenciaDeAprovacao?.cliente?.clienteNome || pendenciaDeAprovacao?.cliente || "-" }</div>
                            <div className="col-3 text-center"><span style={{ color: "#999" }}>Disciplina</span><br/>{ pendenciaDeAprovacao?.disciplina || pendenciaDeAprovacao?.nomeDisciplina || "-" }</div>
                            { (pendenciaDeAprovacao?.totalHorasProBono != '0,00' && !pendenciaDeAprovacao) && ( <><div className="col-3 text-center"><span style={{ color: "#999" }}>Horas Pro Bono</span><br/>{ pendenciaDeAprovacao?.totalHorasProBono || "-" }</div></> )}
                            { (pendenciaDeAprovacao?.totalValorProBono != 'R$ 0,00' && !pendenciaDeAprovacao) && ( <><div className="col-3 text-center"><span style={{ color: "#999" }}>Valor Pro Bono</span><br/>{ pendenciaDeAprovacao?.totalValorProBono || "-" }</div></> )}
                            
                        </div>

                        <div className="modal-divider" style={ { opacity: "0.3" }}><hr /></div>

                        { pendenciaDeAprovacao?.acoes?.unificarFaturamento && (
                            <Flex>
                                <div style={{ width: '100%' }} className="position-relative form-group">
                                    <p className="modal-info">Deseja unificar os faturamentos da Adjuster e Critério Experts?</p>
                                    <ToggleSwitchFilters
                                        key={toggleKey}
                                        config={toggleConfig}
                                        setStatus={(status) => getUnificarFaturamentoToggle(status)}
                                        disab
                                    />
                                </div>
                            </Flex>
                        )}

                        { pendenciaDeAprovacao?.acoes?.unificarFaturamento && (
                            <>
                                {unificarFaturamentoToggle ? (
                                    /* ================= TABELA UNIFICADA (Toggle TRUE) ================= */
                                    <div className="table-responsive">
                                        <table className="table table-sm mb-0">
                                            <thead>
                                                <tr className="table-light" style={{ position: 'sticky', top: 0, zIndex: 5, background: '#fff' }}>
                                                    <th colSpan={9}>Timesheets a serem faturados</th>
                                                </tr>
                                                <tr>
                                                    <th scope="col" className="text-center">Sigla</th>
                                                    <th scope="col" className="text-center">TimeSheet</th>
                                                    <th scope="col" className="text-center">Status</th>
                                                    <th scope="col" className="text-center">Etapa Aprovação</th>
                                                    <th scope="col" className="text-center">Horas P.B</th>
                                                    <th scope="col" className="text-center">Valor P.B</th>
                                                    <th scope="col" className="text-center">Total Horas</th>
                                                    <th scope="col" className="text-center">Valor Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {isLoading ? (
                                                    <tr>
                                                        <td colSpan={9} className="text-center py-4">
                                                            <div className="text-center">
                                                                <div className="text-items-center">
                                                                    <div className="spinner-border ms-auto mt-2" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                                                    <div className="mt-2">
                                                                        <strong style={{ color: "#EE4B21" }}>Aguarde enquanto validamos as informações</strong>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : timesheet.length === 0 ? (
                                                    <tr>
                                                        <td colSpan={9} className="text-center py-4 text-muted">
                                                            Nenhum timesheet encontrado.
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    timesheet.filter((tsItem) => tsItem.vinculado).map((tsItem) => (
                                                        <tr key={tsItem.idTimesheet} className={""} style={{ fontSize: '14px' }}>
                                                            <td className="text-center">{tsItem.sigla}</td>
                                                            <td className="text-center">{tsItem.timeSheetSigla}</td>
                                                            <td className="text-center">{tsItem.statusTimeSheet}</td>
                                                            <td className="text-center">{tsItem.etapaAprovacao}</td>
                                                            <td className="text-center">{formatDecimal(tsItem.horasProBono)}</td>
                                                            <td className="text-center">{formatCurrency(tsItem.valorProBono)}</td>
                                                            <td className="text-center">{formatDecimal(tsItem.totalHorasFaturadas)}</td>
                                                            <td className="text-center">{formatCurrency(tsItem.valorTotalFaturado)}</td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                            <tfoot>
                                                <tr className="table-light" style={{ fontSize: '14px' }}>
                                                    <td className="text-center fw-bold" colSpan={4}>Total</td>
                                                    <td className="text-center fw-bold" >{formatDecimal(totalHorasProBono)}</td>
                                                    <td className="text-center fw-bold" >{formatCurrency(totalValorProBono)}</td>
                                                    <td className="text-center fw-bold" >{formatDecimal(totalHoras)}</td>
                                                    <td className="text-center fw-bold" >{formatCurrency(totalValor)}</td>
                                                    <td className="text-center fw-bold" ></td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                ) : (
                                    /* ================= TABELAS SEPARADAS (Toggle FALSE) ================= */
                                    <>
                                        {/* TABELA 1: CRITERIO */}
                                        <div className="table-responsive mb-4">
                                            <table className="table table-sm mb-0">
                                                <thead>
                                                    <tr className="table-light" style={{ position: 'sticky', top: 0, zIndex: 5, background: '#fff' }}>
                                                        <th colSpan={9}>Timesheets a serem faturados pela Critério Experts</th>
                                                    </tr>
                                                    <tr>
                                                        <th scope="col" className="text-center">Sigla</th>
                                                        <th scope="col" className="text-center">TimeSheet</th>
                                                        <th scope="col" className="text-center">Status</th>
                                                        <th scope="col" className="text-center">Etapa Aprovação</th>
                                                        <th scope="col" className="text-center">Horas P.B</th>
                                                        <th scope="col" className="text-center">Valor P.B</th>
                                                        <th scope="col" className="text-center">Total Horas</th>
                                                        <th scope="col" className="text-center">Valor Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {isLoading ? (
                                                        <tr>
                                                            <td colSpan={9} className="text-center py-4">
                                                                <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status"></div>
                                                            </td>
                                                        </tr>
                                                    ) : timesheet.filter(tsItem => tsItem.vinculado && (tsItem.idEmpresa === 1)).length === 0 ? (
                                                        <tr>
                                                            <td colSpan={9} className="text-center py-4 text-muted">
                                                                Nenhum timesheet da Criterio encontrado.
                                                            </td>
                                                        </tr>
                                                    ) : (
                                                        timesheet.filter(tsItem => tsItem.vinculado && (tsItem.idEmpresa === 1)).map((tsItem) => (
                                                            <tr key={tsItem.idTimesheet} style={{ fontSize: '14px' }}>
                                                                <td className="text-center">{tsItem.sigla}</td>
                                                                <td className="text-center">{tsItem.timeSheetSigla}</td>
                                                                <td className="text-center">{tsItem.statusTimeSheet}</td>
                                                                <td className="text-center">{tsItem.etapaAprovacao}</td>
                                                                <td className="text-center">{formatDecimal(tsItem.horasProBono)}</td>
                                                                <td className="text-center">{formatCurrency(tsItem.valorProBono)}</td>
                                                                <td className="text-center">{formatDecimal(tsItem.totalHorasFaturadas)}</td>
                                                                <td className="text-center">{formatCurrency(tsItem.valorTotalFaturado)}</td>
                                                            </tr>
                                                        ))
                                                    )}
                                                </tbody>
                                                <tfoot>
                                                    <tr className="table-light" style={{ fontSize: '14px' }}>
                                                        <td className="text-center fw-bold" colSpan={4}>Total Criterio</td>
                                                        <td className="text-center fw-bold">{formatDecimal(totalCriterioHorasPB)}</td>
                                                        <td className="text-center fw-bold">{formatCurrency(totalCriterioValorPB)}</td>
                                                        <td className="text-center fw-bold">{formatDecimal(totalCriterioHoras)}</td>
                                                        <td className="text-center fw-bold">{formatCurrency(totalCriterioValor)}</td>
                                                        <td className="text-center fw-bold"></td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>

                                        {/* TABELA 2: ADJUSTER */}
                                        <div className="table-responsive">
                                            <table className="table table-sm mb-0">
                                                <thead>
                                                    <tr className="table-light" style={{ position: 'sticky', top: 0, zIndex: 5, background: '#fff' }}>
                                                        <th colSpan={9}>Timesheets a serem faturados pela Adjuster</th>
                                                    </tr>
                                                    <tr>
                                                        <th scope="col" className="text-center">Sigla</th>
                                                        <th scope="col" className="text-center">TimeSheet</th>
                                                        <th scope="col" className="text-center">Status</th>
                                                        <th scope="col" className="text-center">Etapa Aprovação</th>
                                                        <th scope="col" className="text-center">Horas P.B</th>
                                                        <th scope="col" className="text-center">Valor P.B</th>
                                                        <th scope="col" className="text-center">Total Horas</th>
                                                        <th scope="col" className="text-center">Valor Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {isLoading ? (
                                                        <tr>
                                                            <td colSpan={9} className="text-center py-4">
                                                                <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status"></div>
                                                            </td>
                                                        </tr>
                                                    ) : timesheet.filter(tsItem => tsItem.vinculado && (tsItem.idEmpresa === 2)).length === 0 ? (
                                                        <tr>
                                                            <td colSpan={9} className="text-center py-4 text-muted">
                                                                Nenhum timesheet da Adjuster encontrado.
                                                            </td>
                                                        </tr>
                                                    ) : (
                                                        timesheet.filter(tsItem => tsItem.vinculado && (tsItem.idEmpresa === 2)).map((tsItem) => (
                                                            <tr key={tsItem.idTimesheet} style={{ fontSize: '14px' }}>
                                                                <td className="text-center">{tsItem.sigla}</td>
                                                                <td className="text-center">{tsItem.timeSheetSigla}</td>
                                                                <td className="text-center">{tsItem.statusTimeSheet}</td>
                                                                <td className="text-center">{tsItem.etapaAprovacao}</td>
                                                                <td className="text-center">{formatDecimal(tsItem.horasProBono)}</td>
                                                                <td className="text-center">{formatCurrency(tsItem.valorProBono)}</td>
                                                                <td className="text-center">{formatDecimal(tsItem.totalHorasFaturadas)}</td>
                                                                <td className="text-center">{formatCurrency(tsItem.valorTotalFaturado)}</td>
                                                            </tr>
                                                        ))
                                                    )}
                                                </tbody>
                                                <tfoot>
                                                    <tr className="table-light" style={{ fontSize: '14px' }}>
                                                        <td className="text-center fw-bold" colSpan={4}>Total Adjuster</td>
                                                        <td className="text-center fw-bold">{formatDecimal(totalAdjusterHorasPB)}</td>
                                                        <td className="text-center fw-bold">{formatCurrency(totalAdjusterValorPB)}</td>
                                                        <td className="text-center fw-bold">{formatDecimal(totalAdjusterHoras)}</td>
                                                        <td className="text-center fw-bold">{formatCurrency(totalAdjusterValor)}</td>
                                                        <td className="text-center fw-bold"></td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </>
                                )}
                            </>
                        )}

                        <Flex>
                            <div style={{ width: '100%' }} className="position-relative form-group">
                                <p className="modal-info">{pendenciaDeAprovacao.condicional && pendenciaDeAprovacao.condicional[0].perguntaCondicional} </p>
                                {
                                    pendenciaDeAprovacao.condicional && !pendenciaDeAprovacao.acoes?.unificarFaturamento &&
                                    (
                                        pendenciaDeAprovacao.condicional.map((item, index) => {
                                            return (
                                                <Select
                                                    className="basic-single"
                                                    placeholder={'Selecione uma resposta'}
                                                    key={item.idEtapaAprovacao}
                                                    options={item.condicionalOpcao}
                                                    onChange={(condicional) => getCondicional(item, condicional)}
                                                />
                                            )
                                        })
                                    )
                                }
                            </div>
                        </Flex>

                        <Flex>
                            <div style={{ width: '100%' }} className="position-relative form-group">
                                <textarea rows="3" className="input-form" placeholder='Descrição' name='descricao' onBlur={handleDescricao} />
                            </div>
                        </Flex>
                        
                        <div className="modal-divider" style={{ opacity: "0.3" }}><hr /></div>

                        <Flex>
                            <Flex.Item className="modal-width">
                                <div className="position-relative form-group modal-align-center">
                                    <input className='default-button-red' value='Concluir' type="button" onClick={formActivities} />
                                </div>
                            </Flex.Item>
                        </Flex>
                    </StyledTablePage>
                </StyledForm>
            </Modal>);
    };
